<template>
  <section class="login-hero" aria-labelledby="login-hero-heading">
    <div class="login-hero__body">
      <div class="login-hero__copy">
        <div class="login-hero__badge">
          <v-icon icon="mdi-sparkles" class="login-hero__badge-icon" />
          <span>AI call agent platform</span>
        </div>

        <h1 id="login-hero-heading" class="login-hero__heading">
          Your AI call agent
          <span class="login-hero__heading-highlight">Never Misses a Call.</span>
        </h1>

        <p class="login-hero__description">
          Yandle answers calls, captures leads, books appointments,
          answers customer questions, and works 24/7 using your
          business knowledge.
        </p>
      </div>

      <div class="login-hero__flow login-hero__flow--desktop">
        <LoginHeroFlow :compact="false" />
      </div>

      <div class="login-hero__flow login-hero__flow--mobile">
        <LoginHeroFlow :compact="true" />
      </div>
    </div>

    <footer class="login-hero__footer">
      <LoginMetricChips />
    </footer>
  </section>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import LoginMetricChips from '@/components/Login/LoginMetricChips.vue'

const LoginHeroFlow = defineAsyncComponent(
  () => import('@/components/Login/LoginHeroFlow.vue'),
)

defineOptions({ name: 'LoginHeroSection' })

defineProps({
  isDark: {
    type: Boolean,
    default: true,
  },
  logoUrl: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: 'Yandle',
  },
})
</script>
